const moduleNameKey = "machineOverview";

export const machineOverviewEn = {
  [moduleNameKey]: {
    cyclesLabel: "Job Progress",
    progressLabel: "Progress label",
    progressColorStartLabel: "Progress bar start",
    progressColorEndLabel: "Progress bar end",
    progressColorResetLabel: "Reset to default colors",
    rowLabelMeta: "Parameter {{ index }}: Define a name",
    nodeForGoodQuantity: "Node for good quantity",
    nodeForTotalQuantity: "Node for total quantity",
    roleNodePlaceholder: "Parameter {{ index }}: Select a node",
    statusNodePlaceholder: "Status node",
    statusMappingHeader: "Machine status mapping setup",
    setupWidgetEntries: "Setup widget entries",
    statusLabel: "Mode {{ index }}: Define a name for this mode",
    statusPlaceholder: "Enter a name for this mode",
    statusModeLabel: "Match mode",
    statusColorLabel: "Choose status color",
    statusModeExact: "Exact",
    statusModeInterval: "Interval",
    statusValue: "For which value of the node is the status shown?",
    statusValuePlaceholder: "Enter the value for this status",
    statusMin: "Min",
    statusMax: "Max",
    addStatusMapping: "+ Add status mapping",
    removeStatusMapping: "Remove status mapping",
    addRowLabel: "+ Add row",
    removeRowLabel: "Remove row",
    goodNodeRequired: "Good quantity node required",
    totalNodeRequired: "Total quantity node required",
    rowNodeRequired: "Every row needs a node",
    rowShowUnitLabel: "Show unit",
    rowUnitLabel: "Unit",
    statusNodeRequired: "Status node required",
    statusEntryRequired: "Add at least one status mapping",
    statusLabelRequired: "Define a name for each created mode",
    statusValueRequired: "Status mapping value required",
    statusIntervalInvalid: "Min must be less than max",
    statusDisplayModeLabel: "Status display mode",
    statusDisplayModeBadge: "Badge",
    statusDisplayModeBackground: "Background",
    metrics: {
      metricKindLabel: "Metric",
      addMetricLabel: "+ Add metric",
      removeMetric: "Remove metric",
      optionalSuffix: "(optional)",
      metricKind: {
        remaining_time: "Remaining Time",
        quality: "Quality",
      },
      metricFormula: {
        remaining_time:
          "Remaining time = (Cycle × (Total − Good)) ÷ cycle time unit ÷ Cavities",
        quality: "Quality = Good ÷ (Good + Bad) × 100",
      },
      metricSlot: {
        cycle_time: "Cycle Time",
        total_parts: "Total Parts",
        good_parts: "Good Parts",
        bad_parts: "Bad Parts",
        cavities: "Cavities {{ optional }}",
      },
      // Cycle-time unit selector — the divisor the formula uses to
      // land the result in hours. No default: the user must pick.
      cycleUnitLabel: "Cycle time unit",
      cycleUnit: {
        seconds: "Seconds (s)",
        milliseconds: "Milliseconds (ms)",
        microseconds: "Microseconds (μs)",
      },
      // Placeholder rendered before the user has picked — keeps the
      // dropdown honest (would otherwise fall back to "options[0]"
      // which looks like a selection but is just default rendering).
      cycleUnitPlaceholder: "Select cycle time unit",
      cycleUnitRequired: "Pick a cycle time unit",
      cycle_timeNodeRequired: "Pick a Cycle Time node",
      total_partsNodeRequired: "Pick a Total Parts node",
      good_partsNodeRequired: "Pick a Good Parts node",
      bad_partsNodeRequired: "Pick a Bad Parts node",
    },
    titleLabel: "Chart Title",
    titleInputPlaceholder: "Enter chart title",
    titleRequired: "Title is required",
    machineLabel: "Machine",
    noMachines: "No machines found",
    machinesPlaceholder: "Search machines...",
    machineRequired: "Pick a machine",
    noNodes: "No nodes found",
    nodesPlaceholder: "Search nodes...",
    noUnits: "No units found",
    unitsPlaceholder: "Search units...",
    lookbackLabel: "Lookback",
    noLookbacks: "No lookback options found",
    lookbackPlaceholder: "Select lookback",
    lookbackRequired: "Pick a lookback",
    pollingIntervalLabel: "Polling interval",
    noPollingIntervals: "No polling intervals found",
    pollingIntervalPlaceholder: "Select refresh interval",
    scaleInvalid: "Scaling factor must be a number",
    saveButton: "Save",
    cancelButton: "Cancel",
    imageLabel: "Image",
    dashboardLinkLabel: "Dashboard link",
    noDashboards: "No dashboards found",
    dashboardLinkPlaceholder: "Search dashboards...",
  },
};

export const machineOverviewPtBr = {
  [moduleNameKey]: {
    cyclesLabel: "Progresso do trabalho",
    progressLabel: "Rótulo de progresso",
    progressColorStartLabel: "Início da barra de progresso",
    progressColorEndLabel: "Fim da barra de progresso",
    progressColorResetLabel: "Restaurar cores padrão",
    rowLabelMeta: "Linha {{ index }}: Defina um nome",
    nodeForGoodQuantity: "Nó para quantidade boa",
    nodeForTotalQuantity: "Nó para quantidade total",
    roleNodePlaceholder: "Linha {{ index }}: Selecione um nó",
    statusNodePlaceholder: "Nó de status",
    statusMappingHeader: "Configuração do mapeamento de status da máquina",
    setupWidgetEntries: "Configurar entradas do widget",
    statusLabel: "Modo {{ index }}: Defina um nome para este modo",
    statusPlaceholder: "Digite um nome para este modo",
    statusModeLabel: "Modo de correspondência",
    statusColorLabel: "Escolher cor do status",
    statusModeExact: "Exato",
    statusModeInterval: "Intervalo",
    statusValue: "Para qual valor do nó o status é exibido?",
    statusValuePlaceholder: "Digite o valor para este status",
    statusMin: "Mínimo",
    statusMax: "Máximo",
    addStatusMapping: "+ Adicionar mapeamento de status",
    removeStatusMapping: "Remover mapeamento de status",
    addRowLabel: "+ Adicionar linha",
    removeRowLabel: "Remover linha",
    goodNodeRequired: "Nó da quantidade boa é obrigatório",
    totalNodeRequired: "Nó da quantidade total é obrigatório",
    rowNodeRequired: "Cada linha precisa de um nó",
    rowShowUnitLabel: "Mostrar unidade",
    rowUnitLabel: "Unidade",
    statusNodeRequired: "Nó de status é obrigatório",
    statusEntryRequired: "Adicione pelo menos um mapeamento de status",
    statusLabelRequired: "Defina um nome para cada modo criado",
    statusValueRequired: "Valor do mapeamento de status é obrigatório",
    statusIntervalInvalid: "Mínimo deve ser menor que máximo",
    statusDisplayModeLabel: "Modo de exibição do status",
    statusDisplayModeBadge: "Distintivo",
    statusDisplayModeBackground: "Fundo",
    metrics: {
      metricKindLabel: "Métrica",
      addMetricLabel: "+ Adicionar métrica",
      removeMetric: "Remover métrica",
      optionalSuffix: "(opcional)",
      metricKind: {
        remaining_time: "Tempo Restante",
        quality: "Qualidade",
      },
      metricFormula: {
        remaining_time:
          "Tempo restante = (Ciclo × (Total − Boas)) ÷ unidade do tempo de ciclo ÷ Cavidades",
        quality: "Qualidade = Boas ÷ (Boas + Ruins) × 100",
      },
      metricSlot: {
        cycle_time: "Tempo de Ciclo",
        total_parts: "Peças Totais",
        good_parts: "Peças Boas",
        bad_parts: "Peças Ruins",
        cavities: "Cavidades {{ optional }}",
      },
      // Cycle-time unit selector — o divisor que a fórmula usa para
      // chegar ao resultado em horas. Sem padrão: o usuário deve
      // escolher.
      cycleUnitLabel: "Unidade do tempo de ciclo",
      cycleUnit: {
        seconds: "Segundos (s)",
        milliseconds: "Milissegundos (ms)",
        microseconds: "Microssegundos (μs)",
      },
      cycleUnitPlaceholder: "Selecione uma unidade do tempo de ciclo",
      cycleUnitRequired: "Escolha uma unidade para o tempo de ciclo",
      cycle_timeNodeRequired: "Selecione um nó de Tempo de Ciclo",
      total_partsNodeRequired: "Selecione um nó de Peças Totais",
      good_partsNodeRequired: "Selecione um nó de Peças Boas",
      bad_partsNodeRequired: "Selecione um nó de Peças Ruins",
    },
    titleLabel: "Título do Gráfico",
    titleInputPlaceholder: "Digite o título do gráfico",
    titleRequired: "Título é obrigatório",
    machineLabel: "Máquina",
    noMachines: "Nenhuma máquina encontrada",
    machinesPlaceholder: "Buscar máquinas...",
    machineRequired: "Selecione uma máquina",
    noNodes: "Nenhum nó encontrado",
    nodesPlaceholder: "Buscar nós...",
    noUnits: "Nenhuma unidade encontrada",
    unitsPlaceholder: "Buscar unidades...",
    lookbackLabel: "Janela de leitura",
    noLookbacks: "Nenhuma janela de leitura encontrada",
    lookbackPlaceholder: "Selecione a janela",
    lookbackRequired: "Selecione um período de leitura",
    pollingIntervalLabel: "Intervalo de atualização",
    noPollingIntervals: "Nenhum intervalo de atualização encontrado",
    pollingIntervalPlaceholder: "Selecione o intervalo de atualização",
    scaleInvalid: "O fator de escala deve ser um número",
    saveButton: "Salvar",
    cancelButton: "Cancelar",
    imageLabel: "Imagem",
    dashboardLinkLabel: "Link do painel",
    noDashboards: "Nenhum painel encontrado",
    dashboardLinkPlaceholder: "Buscar painéis...",
  },
};

export const machineOverviewDe = {
  [moduleNameKey]: {
    cyclesLabel: "Arbeitsfortschritt",
    progressLabel: "Fortschritts-Label",
    progressColorStartLabel: "Fortschrittsbalken Start",
    progressColorEndLabel: "Fortschrittsbalken Ende",
    progressColorResetLabel: "Auf Standardfarben zurücksetzen",
    rowLabelMeta: "Zeile {{ index }}: Namen definieren",
    nodeForGoodQuantity: "Knoten für gute Menge",
    nodeForTotalQuantity: "Knoten für Gesamtmenge",
    roleNodePlaceholder: "Parameter {{ index }}: Knoten auswählen",
    statusNodePlaceholder: "Statusknoten",
    statusMappingHeader: "Maschinenstatus-Zuordnung einrichten",
    setupWidgetEntries: "Widget-Einträge einrichten",
    statusLabel: "Modus {{ index }}: Namen für diesen Modus definieren",
    statusPlaceholder: "Geben Sie einen Namen für diesen Modus ein",
    statusModeLabel: "Abgleichmodus",
    statusColorLabel: "Statusfarbe wählen",
    statusModeExact: "Exakt",
    statusModeInterval: "Bereich",
    statusValue: "Für welchen Wert des Knotens wird der Status angezeigt?",
    statusValuePlaceholder: "Geben Sie den Wert für diesen Status ein",
    statusMin: "Minimum",
    statusMax: "Maximum",
    addStatusMapping: "+ Status-Zuordnung hinzufügen",
    removeStatusMapping: "Status-Zuordnung entfernen",
    addRowLabel: "+ Zeile hinzufügen",
    removeRowLabel: "Zeile entfernen",
    goodNodeRequired: "Knoten für gute Menge erforderlich",
    totalNodeRequired: "Knoten für Gesamtmenge erforderlich",
    rowNodeRequired: "Jede Zeile benötigt einen Knoten",
    rowShowUnitLabel: "Einheit anzeigen",
    rowUnitLabel: "Einheit",
    statusNodeRequired: "Statusknoten erforderlich",
    statusEntryRequired: "Fügen Sie mindestens eine Status-Zuordnung hinzu",
    statusLabelRequired: "Geben Sie für jedes erstellte Modus einen Namen an",
    statusValueRequired: "Status-Zuordnungswert erforderlich",
    statusIntervalInvalid: "Minimum muss kleiner als Maximum sein",
    statusDisplayModeLabel: "Status-Anzeigemodus",
    statusDisplayModeBadge: "Abzeichen",
    statusDisplayModeBackground: "Hintergrund",
    metrics: {
      metricKindLabel: "Metrik",
      addMetricLabel: "+ Metrik hinzufügen",
      removeMetric: "Metrik entfernen",
      optionalSuffix: "(optional)",
      metricKind: {
        remaining_time: "Verbleibende Zeit",
        quality: "Qualität",
      },
      metricFormula: {
        remaining_time:
          "Verbleibende Zeit = (Zyklus × (Gesamt − Gut)) ÷ Zykluszeiteinheit ÷ Kavitäten",
        quality: "Qualität = Gut ÷ (Gut + Schlecht) × 100",
      },
      metricSlot: {
        cycle_time: "Zykluszeit",
        total_parts: "Teile gesamt",
        good_parts: "Gut-Teile",
        bad_parts: "Schlecht-Teile",
        cavities: "Kavitäten {{ optional }}",
      },
      // Cycle-time unit selector — Divisor, den die Formel verwendet,
      // um das Ergebnis in Stunden abzubilden. Kein Standardwert: der
      // Benutzer muss auswählen.
      cycleUnitLabel: "Zykluszeiteinheit",
      cycleUnit: {
        seconds: "Sekunden (s)",
        milliseconds: "Millisekunden (ms)",
        microseconds: "Mikrosekunden (μs)",
      },
      cycleUnitPlaceholder: "Zykluszeiteinheit auswählen",
      cycleUnitRequired: "Eine Einheit für die Zykluszeit auswählen",
      cycle_timeNodeRequired: "Zykluszeit-Knoten auswählen",
      total_partsNodeRequired: "Knoten für Teile gesamt auswählen",
      good_partsNodeRequired: "Knoten für Gut-Teile auswählen",
      bad_partsNodeRequired: "Knoten für Schlecht-Teile auswählen",
    },
    titleLabel: "Titel des Diagramms",
    titleInputPlaceholder: "Titel des Diagramms eingeben",
    titleRequired: "Titel ist erforderlich",
    machineLabel: "Maschine",
    noMachines: "Keine Maschinen gefunden",
    machinesPlaceholder: "Maschinen suchen...",
    machineRequired: "Maschine auswählen",
    noNodes: "Keine Knoten gefunden",
    nodesPlaceholder: "Knoten suchen...",
    noUnits: "Keine Einheiten gefunden",
    unitsPlaceholder: "Einheiten suchen...",
    lookbackLabel: "Rückblick",
    noLookbacks: "Keine Rückblicke gefunden",
    lookbackPlaceholder: "Rückblick wählen",
    lookbackRequired: "Rückblick auswählen",
    pollingIntervalLabel: "Aktualisierungsintervall",
    noPollingIntervals: "Keine Aktualisierungsintervalle gefunden",
    pollingIntervalPlaceholder: "Intervall wählen",
    scaleInvalid: "Der Skalierungsfaktor muss eine Zahl sein",
    saveButton: "Speichern",
    cancelButton: "Abbrechen",
    imageLabel: "Bild",
    dashboardLinkLabel: "Dashboard-Link",
    noDashboards: "Keine Dashboards gefunden",
    dashboardLinkPlaceholder: "Dashboards suchen...",
  },
};

export const machineOverviewZhHans = {
  [moduleNameKey]: {
    cyclesLabel: "工作进度标签",
    progressLabel: "进度标签",
    progressColorStartLabel: "进度条开始",
    progressColorEndLabel: "进度条结束",
    progressColorResetLabel: "重置为默认颜色",
    rowLabelMeta: "参数 {{ index }}: 定义名称",
    nodeForGoodQuantity: "良品数量节点",
    nodeForTotalQuantity: "总数量节点",
    roleNodePlaceholder: "参数 {{ index }}: 选择节点",
    statusNodePlaceholder: "状态节点",
    statusMappingHeader: "机器状态映射设置",
    setupWidgetEntries: "设置小部件条目",
    statusLabel: "模式 {{ index }}: 为此模式定义名称",
    statusPlaceholder: "输入状态名称",
    statusModeLabel: "匹配模式",
    statusColorLabel: "选择状态颜色",
    statusModeExact: "精确",
    statusModeInterval: "区间",
    statusValue: "节点的哪个值显示该状态？",
    statusValuePlaceholder: "输入此状态的值",
    statusMin: "最小",
    statusMax: "最大",
    addStatusMapping: "+ 添加状态映射",
    removeStatusMapping: "移除状态映射",
    addRowLabel: "+ 添加行",
    removeRowLabel: "移除行",
    goodNodeRequired: "必须选择良品数量节点",
    totalNodeRequired: "必须选择总数量节点",
    rowNodeRequired: "每行都需要节点",
    rowShowUnitLabel: "显示单位",
    rowUnitLabel: "单位",
    statusNodeRequired: "必须选择状态节点",
    statusEntryRequired: "请至少添加一个状态映射",
    statusLabelRequired: "请为每个创建的模式定义名称",
    statusValueRequired: "状态映射值是必填项",
    statusIntervalInvalid: "最小值必须小于最大值",
    statusDisplayModeLabel: "状态显示模式",
    statusDisplayModeBadge: "徽章",
    statusDisplayModeBackground: "背景",
    metrics: {
      metricKindLabel: "指标",
      addMetricLabel: "+ 添加指标",
      removeMetric: "删除指标",
      optionalSuffix: "(可选)",
      metricKind: {
        remaining_time: "剩余时间",
        quality: "合格率",
      },
      metricFormula: {
        remaining_time:
          "剩余时间 = (周期 × (总数 − 合格)) ÷ 周期时间单位 ÷ 模腔数",
        quality: "合格率 = 合格 ÷ (合格 + 不合格) × 100",
      },
      metricSlot: {
        cycle_time: "周期时间",
        total_parts: "总零件数",
        good_parts: "合格零件数",
        bad_parts: "不合格零件数",
        cavities: "模腔数 {{ optional }}",
      },
      // 周期时间单位选择器 —— 公式用来将结果换算为小时的除数。
      // 没有默认值：用户必须选择。
      cycleUnitLabel: "周期时间单位",
      cycleUnit: {
        seconds: "秒 (s)",
        milliseconds: "毫秒 (ms)",
        microseconds: "微秒 (μs)",
      },
      cycleUnitPlaceholder: "选择周期时间单位",
      cycleUnitRequired: "请选择周期时间单位",
      cycle_timeNodeRequired: "请选择周期时间节点",
      total_partsNodeRequired: "请选择总零件数节点",
      good_partsNodeRequired: "请选择合格零件数节点",
      bad_partsNodeRequired: "请选择不合格零件数节点",
    },
    titleLabel: "图表标题",
    titleInputPlaceholder: "输入图表标题",
    titleRequired: "标题是必填项",
    machineLabel: "机器",
    noMachines: "未找到机器",
    machinesPlaceholder: "搜索机器...",
    machineRequired: "选择机器",
    noNodes: "未找到节点",
    nodesPlaceholder: "搜索节点...",
    noUnits: "未找到单位",
    unitsPlaceholder: "搜索单位...",
    lookbackLabel: "回溯时间",
    noLookbacks: "未找到回溯时间",
    lookbackPlaceholder: "选择回溯时间",
    lookbackRequired: "选择回溯时间",
    pollingIntervalLabel: "轮询间隔",
    noPollingIntervals: "未找到轮询间隔",
    pollingIntervalPlaceholder: "选择刷新间隔",
    scaleInvalid: "缩放系数必须为数字",
    saveButton: "保存",
    cancelButton: "取消",
    imageLabel: "图片",
    dashboardLinkLabel: "仪表板链接",
    noDashboards: "未找到仪表板",
    dashboardLinkPlaceholder: "搜索仪表板...",
  },
};

export const machineOverviewIt = {
  [moduleNameKey]: {
    cyclesLabel: "Progresso lavoro",
    progressLabel: "Etichetta progresso",
    progressColorStartLabel: "Inizio barra di avanzamento",
    progressColorEndLabel: "Fine barra di avanzamento",
    progressColorResetLabel: "Ripristina colori predefiniti",
    rowLabelMeta: "Parametro {{ index }}: Definisci un nome",
    nodeForGoodQuantity: "Nodo per quantità buona",
    nodeForTotalQuantity: "Nodo per quantità totale",
    roleNodePlaceholder: "Parametro {{ index }}: Seleziona un nodo",
    statusNodePlaceholder: "Nodo stato",
    statusMappingHeader: "Configurazione mappatura stato macchina",
    setupWidgetEntries: "Configura voci widget",
    statusLabel: "Modalità {{ index }}: Definisci un nome per questa modalità",
    statusPlaceholder: "Inserisci il nome per questa modalità",
    statusModeLabel: "Modalità di corrispondenza",
    statusColorLabel: "Scegli il colore dello stato",
    statusModeExact: "Esatto",
    statusModeInterval: "Intervallo",
    statusValue: "Per quale valore del nodo viene mostrato lo stato?",
    statusValuePlaceholder: "Inserisci il valore per questo stato",
    statusMin: "Min",
    statusMax: "Max",
    addStatusMapping: "+ Aggiungi mappatura stato",
    removeStatusMapping: "Rimuovi mappatura stato",
    addRowLabel: "+ Aggiungi riga",
    removeRowLabel: "Rimuovi riga",
    goodNodeRequired: "Nodo quantità buona obbligatorio",
    totalNodeRequired: "Nodo quantità totale obbligatorio",
    rowNodeRequired: "Ogni riga richiede un nodo",
    rowShowUnitLabel: "Mostra unità",
    rowUnitLabel: "Unità",
    statusNodeRequired: "Nodo stato obbligatorio",
    statusEntryRequired: "Aggiungi almeno una mappatura stato",
    statusLabelRequired: "Definisci un nome per ogni modalità creata",
    statusValueRequired: "Valore mappatura stato obbligatorio",
    statusIntervalInvalid: "Il minimo deve essere minore del massimo",
    statusDisplayModeLabel: "Modalità di visualizzazione dello stato",
    statusDisplayModeBadge: "Distintivo",
    statusDisplayModeBackground: "Sfondo",
    metrics: {
      metricKindLabel: "Metrica",
      addMetricLabel: "+ Aggiungi metrica",
      removeMetric: "Rimuovi metrica",
      optionalSuffix: "(opzionale)",
      metricKind: {
        remaining_time: "Tempo Rimanente",
        quality: "Qualità",
      },
      metricFormula: {
        remaining_time:
          "Tempo rimanente = (Ciclo × (Totale − Buoni)) ÷ unità del tempo di ciclo ÷ Cavità",
        quality: "Qualità = Buoni ÷ (Buoni + Scarti) × 100",
      },
      metricSlot: {
        cycle_time: "Tempo Ciclo",
        total_parts: "Pezzi Totali",
        good_parts: "Pezzi Buoni",
        bad_parts: "Pezzi Scarti",
        cavities: "Cavità {{ optional }}",
      },
      // Cycle-time unit selector — divisore che la formula usa per
      // portare il risultato in ore. Nessun valore predefinito:
      // l'utente deve scegliere.
      cycleUnitLabel: "Unità del tempo di ciclo",
      cycleUnit: {
        seconds: "Secondi (s)",
        milliseconds: "Millisecondi (ms)",
        microseconds: "Microsecondi (μs)",
      },
      cycleUnitPlaceholder: "Seleziona un'unità del tempo di ciclo",
      cycleUnitRequired: "Seleziona un'unità per il tempo di ciclo",
      cycle_timeNodeRequired: "Seleziona un nodo Tempo Ciclo",
      total_partsNodeRequired: "Seleziona un nodo Pezzi Totali",
      good_partsNodeRequired: "Seleziona un nodo Pezzi Buoni",
      bad_partsNodeRequired: "Seleziona un nodo Pezzi Scarti",
    },
    titleLabel: "Titolo del Grafico",
    titleInputPlaceholder: "Inserisci il titolo del grafico",
    titleRequired: "Il titolo è obbligatorio",
    machineLabel: "Macchina",
    noMachines: "Nessuna macchina trovata",
    machinesPlaceholder: "Cerca macchine...",
    machineRequired: "Seleziona una macchina",
    noNodes: "Nessun nodo trovato",
    nodesPlaceholder: "Cerca nodi...",
    noUnits: "Nessuna unità trovata",
    unitsPlaceholder: "Cerca unità...",
    lookbackLabel: "Periodo di osservazione",
    noLookbacks: "Nessun periodo di osservazione trovato",
    lookbackPlaceholder: "Seleziona periodo",
    lookbackRequired: "Seleziona un periodo di osservazione",
    pollingIntervalLabel: "Intervallo di aggiornamento",
    noPollingIntervals: "Nessun intervallo di aggiornamento trovato",
    pollingIntervalPlaceholder: "Seleziona intervallo",
    scaleInvalid: "Il fattore di scala deve essere un numero",
    saveButton: "Salva",
    cancelButton: "Annulla",
    imageLabel: "Immagine",
    dashboardLinkLabel: "Link dashboard",
    noDashboards: "Nessuna dashboard trovata",
    dashboardLinkPlaceholder: "Cerca dashboard...",
  },
};

export const machineOverviewEs = {
  [moduleNameKey]: {
    cyclesLabel: "Etiqueta de ciclos",
    progressLabel: "Etiqueta de progreso",
    progressColorStartLabel: "Inicio de la barra de progreso",
    progressColorEndLabel: "Fin de la barra de progreso",
    progressColorResetLabel: "Restablecer colores predeterminados",
    rowLabelMeta: "Parámetro {{ index }}: Definir un nombre",
    nodeForGoodQuantity: "Nodo para cantidad buena",
    nodeForTotalQuantity: "Nodo para cantidad total",
    roleNodePlaceholder: "Parámetro {{ index }}: Seleccionar un nodo",
    statusNodePlaceholder: "Nodo de estado",
    statusMappingHeader: "Configuración del mapeo de estado de máquina",
    setupWidgetEntries: "Configurar entradas del widget",
    statusLabel: "Modo {{ index }}: Definir un nombre para este modo",
    statusPlaceholder: "Ingrese un nombre para este modo",
    statusModeLabel: "Modo de coincidencia",
    statusColorLabel: "Elegir color de estado",
    statusModeExact: "Exacto",
    statusModeInterval: "Intervalo",
    statusValue: "¿Para qué valor del nodo se muestra el estado?",
    statusValuePlaceholder: "Ingrese el valor para este estado",
    statusMin: "Mín",
    statusMax: "Máx",
    addStatusMapping: "+ Agregar mapeo de estado",
    removeStatusMapping: "Eliminar mapeo de estado",
    addRowLabel: "+ Agregar fila",
    removeRowLabel: "Eliminar fila",
    goodNodeRequired: "Nodo de cantidad buena obligatorio",
    totalNodeRequired: "Nodo de cantidad total obligatorio",
    rowNodeRequired: "Cada fila necesita un nodo",
    rowShowUnitLabel: "Mostrar unidad",
    rowUnitLabel: "Unidad",
    statusNodeRequired: "Nodo de estado obligatorio",
    statusEntryRequired: "Agrega al menos un mapeo de estado",
    statusLabelRequired: "Definir un nombre para cada modo creado",
    statusValueRequired: "Valor de mapeo de estado obligatorio",
    statusIntervalInvalid: "El mínimo debe ser menor que el máximo",
    statusDisplayModeLabel: "Modo de visualización del estado",
    statusDisplayModeBadge: "Distintivo",
    statusDisplayModeBackground: "Fondo",
    metrics: {
      metricKindLabel: "Métrica",
      addMetricLabel: "+ Añadir métrica",
      removeMetric: "Eliminar métrica",
      optionalSuffix: "(opcional)",
      metricKind: {
        remaining_time: "Tiempo Restante",
        quality: "Calidad",
      },
      metricFormula: {
        remaining_time:
          "Tiempo restante = (Ciclo × (Total − Buenas)) ÷ unidad del tiempo de ciclo ÷ Cavidades",
        quality: "Calidad = Buenas ÷ (Buenas + Defectuosas) × 100",
      },
      metricSlot: {
        cycle_time: "Tiempo de Ciclo",
        total_parts: "Piezas Totales",
        good_parts: "Piezas Buenas",
        bad_parts: "Piezas Defectuosas",
        cavities: "Cavidades {{ optional }}",
      },
      // Cycle-time unit selector — divisor que la fórmula usa para
      // llevar el resultado a horas. Sin valor predeterminado: el
      // usuario debe elegir.
      cycleUnitLabel: "Unidad del tiempo de ciclo",
      cycleUnit: {
        seconds: "Segundos (s)",
        milliseconds: "Milisegundos (ms)",
        microseconds: "Microsegundos (μs)",
      },
      cycleUnitPlaceholder: "Selecciona una unidad del tiempo de ciclo",
      cycleUnitRequired: "Selecciona una unidad para el tiempo de ciclo",
      cycle_timeNodeRequired: "Selecciona un nodo de Tiempo de Ciclo",
      total_partsNodeRequired: "Selecciona un nodo de Piezas Totales",
      good_partsNodeRequired: "Selecciona un nodo de Piezas Buenas",
      bad_partsNodeRequired: "Selecciona un nodo de Piezas Defectuosas",
    },
    titleLabel: "Título del Gráfico",
    titleInputPlaceholder: "Ingrese el título del gráfico",
    titleRequired: "El título es obligatorio",
    machineLabel: "Máquina",
    noMachines: "No se encontraron máquinas",
    machinesPlaceholder: "Buscar máquinas...",
    machineRequired: "Seleccione una máquina",
    noNodes: "No se encontraron nodos",
    nodesPlaceholder: "Buscar nodos...",
    noUnits: "No se encontraron unidades",
    unitsPlaceholder: "Buscar unidades...",
    lookbackLabel: "Periodo de búsqueda",
    noLookbacks: "No se encontraron periodos de búsqueda",
    lookbackPlaceholder: "Selecciona el periodo",
    lookbackRequired: "Seleccione un período de búsqueda",
    pollingIntervalLabel: "Intervalo de actualización",
    noPollingIntervals: "No se encontraron intervalos de actualización",
    pollingIntervalPlaceholder: "Seleccionar intervalo",
    scaleInvalid: "El factor de escala debe ser un número",
    saveButton: "Guardar",
    cancelButton: "Cancelar",
    imageLabel: "Imagen",
    dashboardLinkLabel: "Enlace del panel",
    noDashboards: "No se encontraron paneles",
    dashboardLinkPlaceholder: "Buscar paneles...",
  },
};

export const machineOverviewNl = {
  [moduleNameKey]: {
    addRowLabel: "+ Rij toevoegen",
    addStatusMapping: "+ Statusmapping toevoegen",
    cyclesLabel: "Voortgang",
    goodNodeRequired: "Knooppunt voor goede hoeveelheid vereist",
    nodeForGoodQuantity: "Knooppunt voor goede hoeveelheid",
    nodeForTotalQuantity: "Knooppunt voor totale hoeveelheid",
    progressLabel: "Voortgangslabel",
    progressColorStartLabel: "Begin voortgangsbalk",
    progressColorEndLabel: "Einde voortgangsbalk",
    progressColorResetLabel: "Standaardkleuren herstellen",
    removeRowLabel: "Rij verwijderen",
    removeStatusMapping: "Statusmapping verwijderen",
    roleNodePlaceholder: "Parameter {{ index }}: Kies een knooppunt",
    rowLabelMeta: "Parameter {{ index }}: Stel een naam in",
    rowNodeRequired: "Elke rij heeft een knooppunt nodig",
    rowShowUnitLabel: "Eenheid weergeven",
    rowUnitLabel: "Eenheid",
    setupWidgetEntries: "Widgetitems instellen",
    statusColorLabel: "Statuskleur kiezen",
    statusDisplayModeBackground: "Achtergrond",
    statusDisplayModeBadge: "Badge",
    statusDisplayModeLabel: "Statusweergavemodus",
    statusEntryRequired: "Voeg minstens één statusmapping toe",
    statusIntervalInvalid: "Minimum moet kleiner zijn dan maximum",
    statusLabel: "Modus {{ index }}: Stel een naam in voor deze modus",
    statusLabelRequired: "Stel een naam in voor elke aangemaakte modus",
    statusMappingHeader: "Setup machine-statusmapping",
    statusMax: "Max",
    statusMin: "Min",
    statusModeExact: "Exact",
    statusModeInterval: "Interval",
    statusModeLabel: "Matchmodus",
    statusNodePlaceholder: "Statusknooppunt",
    statusNodeRequired: "Statusknooppunt vereist",
    statusPlaceholder: "Voer een naam in voor deze modus",
    statusValue:
      "Voor welke waarde van het knooppunt wordt de status weergegeven?",
    statusValuePlaceholder: "Voer de waarde in voor deze status",
    statusValueRequired: "Statusmappingwaarde is vereist",
    totalNodeRequired: "Knooppunt voor totale hoeveelheid vereist",
    metrics: {
      metricKindLabel: "Metriek",
      addMetricLabel: "+ Metriek toevoegen",
      removeMetric: "Metriek verwijderen",
      optionalSuffix: "(optioneel)",
      metricKind: {
        remaining_time: "Resterende tijd",
        quality: "Kwaliteit",
      },
      metricFormula: {
        remaining_time:
          "Resterende tijd = (Cyclus × (Totaal − Goed)) ÷ cyclus-tijd-eenheid ÷ Caviteiten",
        quality: "Kwaliteit = Goed ÷ (Goed + Slecht) × 100",
      },
      metricSlot: {
        cycle_time: "Cyclustijd",
        total_parts: "Totaal onderdelen",
        good_parts: "Goede onderdelen",
        bad_parts: "Slechte onderdelen",
        cavities: "Caviteiten {{ optional }}",
      },
      // Cycle-time unit selector — divisor the formula uses to land
      // its result in hours. No default: the user must pick.
      cycleUnitLabel: "Cyclustijdeenheid",
      cycleUnit: {
        seconds: "Seconden (s)",
        milliseconds: "Milliseconden (ms)",
        microseconds: "Microseconden (μs)",
      },
      // Placeholder rendered before the user has picked — keeps the
      // dropdown honest (would otherwise fall back to "options[0]"
      // which looks like a selection but is just default rendering).
      cycleUnitPlaceholder: "Cyclustijdeenheid kiezen",
      cycleUnitRequired: "Kies een cyclustijdeenheid",
      cycle_timeNodeRequired: "Kies een Cyclustijd-knooppunt",
      total_partsNodeRequired: "Kies een Totaal onderdelen-knooppunt",
      good_partsNodeRequired: "Kies een Goede onderdelen-knooppunt",
      bad_partsNodeRequired: "Kies een Slechte onderdelen-knooppunt",
    },
    titleLabel: "Grafiektitel",
    titleInputPlaceholder: "Typ de grafiektitel",
    titleRequired: "Titel is vereist",
    machineLabel: "Machine",
    noMachines: "Geen machines gevonden",
    machinesPlaceholder: "Machines zoeken...",
    machineRequired: "Kies een machine",
    noNodes: "Geen knooppunten gevonden",
    nodesPlaceholder: "Knooppunten zoeken...",
    noUnits: "Geen eenheden gevonden",
    unitsPlaceholder: "Eenheden",
    lookbackLabel: "Terugkijkperiode",
    noLookbacks: "Geen terugkijkperiodes gevonden",
    lookbackPlaceholder: "Selecteer een terugkijkperiode",
    lookbackRequired: "Kies een terugkijkperiode",
    pollingIntervalLabel: "Polling-interval",
    noPollingIntervals: "Geen polling-intervallen gevonden",
    pollingIntervalPlaceholder: "Polling-interval kiezen",
    scaleInvalid: "De schaalfactor moet een getal zijn",
    saveButton: "Opslaan",
    cancelButton: "Annuleren",
    imageLabel: "Afbeelding",
    dashboardLinkLabel: "Dashboardlink",
    noDashboards: "Geen dashboards gevonden",
    dashboardLinkPlaceholder: "Dashboards zoeken...",
  },
};

export const machineOverviewTr = {
  [moduleNameKey]: {
    addRowLabel: "+ Satır ekle",
    addStatusMapping: "+ Durum eşlemesi ekle",
    cyclesLabel: "İş İlerlemesi",
    goodNodeRequired: "İyi miktarda düğüm gerekli",
    nodeForGoodQuantity: "İyi miktar için düğüm",
    nodeForTotalQuantity: "Toplam miktar için düğüm",
    progressLabel: "İlerleme etiketi",
    progressColorStartLabel: "İlerleme çubuğu başlangıcı",
    progressColorEndLabel: "İlerleme çubuğu sonu",
    progressColorResetLabel: "Varsayılan renklere sıfırla",
    removeRowLabel: "Satırı kaldır",
    removeStatusMapping: "Durum eşlemesini kaldır",
    roleNodePlaceholder: "Parametre {{ index }}: Bir düğüm seçin",
    rowLabelMeta: "Parametre {{ index }}: Bir ad tanımlayın",
    rowNodeRequired: "Her satırın bir düğüme ihtiyacı vardır",
    rowShowUnitLabel: "Birim göster",
    rowUnitLabel: "Birim",
    setupWidgetEntries: "Widget girişlerini ayarlama",
    statusColorLabel: "Durum rengini seçin",
    statusDisplayModeBackground: "Arka plan",
    statusDisplayModeBadge: "Rozet",
    statusDisplayModeLabel: "Durum görüntüleme modu",
    statusEntryRequired: "En az bir durum eşlemesi ekleyin",
    statusIntervalInvalid: "Min. maksimumdan az olmalıdır",
    statusLabel: "Mod {{ index }}: Bu mod için bir ad tanımlayın",
    statusMappingHeader: "Makine durumu eşleme kurulumu",
    statusMax: "Maksimum",
    statusMin: "Min.",
    statusModeExact: "Bire bir aynı",
    statusModeInterval: "Aralık",
    statusModeLabel: "Maç modu",
    statusNodePlaceholder: "Durum düğümü",
    statusNodeRequired: "Durum düğümü gerekli",
    statusLabelRequired: "Oluşturulan her mod için bir ad tanımla",
    statusPlaceholder: "Bu mod için bir ad girin",
    statusValue: "Durum düğümün hangi değeri için gösteriliyor?",
    statusValuePlaceholder: "Bu durumun değerini girin",
    statusValueRequired: "Durum eşleme değeri gerekli",
    totalNodeRequired: "Gerekli toplam miktar düğümü",
    metrics: {
      metricKindLabel: "Metrik",
      addMetricLabel: "+ Metrik ekle",
      removeMetric: "Metriği kaldır",
      optionalSuffix: "(isteğe bağlı)",
      metricKind: {
        remaining_time: "Kalan Süre",
        quality: "Kalite",
      },
      metricFormula: {
        remaining_time:
          "Kalan süre = (Çevrim × (Toplam − İyi)) ÷ çevrim süresi birimi ÷ Kaviteler",
        quality: "Kalite = İyi ÷ (İyi + Hatalı) × 100",
      },
      metricSlot: {
        cycle_time: "Çevrim Süresi",
        total_parts: "Toplam Parça",
        good_parts: "İyi Parça",
        bad_parts: "Hatalı Parça",
        cavities: "Kaviteler {{ optional }}",
      },
      cycleUnitLabel: "Çevrim süresi birimi",
      cycleUnit: {
        seconds: "Saniye (s)",
        milliseconds: "Milisaniye (ms)",
        microseconds: "Mikrosaniye (μs)",
      },
      cycleUnitPlaceholder: "Çevrim süresi birimini seçin",
      cycleUnitRequired: "Bir çevrim süresi birimi seçin",
      cycle_timeNodeRequired: "Bir Çevrim Süresi düğümü seçin",
      total_partsNodeRequired: "Bir Toplam Parça düğümü seçin",
      good_partsNodeRequired: "Bir İyi Parça düğümü seçin",
      bad_partsNodeRequired: "Bir Hatalı Parça düğümü seçin",
    },
    titleLabel: "Grafik Başlığı",
    titleInputPlaceholder: "Grafik başlığını girin",
    titleRequired: "Başlık gerekli",
    machineLabel: "Makine",
    noMachines: "Hiçbir makine bulunamadı",
    machinesPlaceholder: "Arama makineleri...",
    machineRequired: "Bir makine seç",
    noNodes: "Hiçbir düğüm bulunamadı",
    nodesPlaceholder: "Düğümleri ara...",
    noUnits: "Birim bulunamadı",
    unitsPlaceholder: "Birimleri arayın...",
    lookbackLabel: "Geriye bakma",
    noLookbacks: "Hiçbir geriye bakma bulunamadı",
    lookbackPlaceholder: "Yeniden incelemeyi seçin",
    lookbackRequired: "Bir yeniden inceleme seçin",
    pollingIntervalLabel: "Yoklama aralığı",
    noPollingIntervals: "Hiçbir yoklama aralığı bulunamadı",
    pollingIntervalPlaceholder: "Yenileme aralığını seçin",
    scaleInvalid: "Ölçek faktörü bir sayı olmalıdır",
    saveButton: "Kaydetmek",
    cancelButton: "İptal etmek",
    imageLabel: "Resim",
    dashboardLinkLabel: "Kontrol paneli bağlantısı",
    noDashboards: "Kontrol paneli bulunamadı",
    dashboardLinkPlaceholder: "Kontrol panellerinde ara...",
  },
};
